import React from 'react'
import RenderProfilePicture from '../../_helpers/profile-picture'

export default function RenderProfile({ profileUrl, name, type, cached }) {
  return (<>
    <div className="mx-auto mb-3">
      <RenderProfilePicture height={100} width={100} image={profileUrl} circle cached={cached} className='m-auto' />
    </div>
    <div className="row">
      <div className='col-12 text-center'>
        <h5 className='m-0'>{name}</h5>
        <span className='text-muted'>{type}</span>
      </div>
    </div>
  </>
  )
}
